<template>
    <el-select 
        v-bind:class="type === isType ? (initialValue ? 'success' : 'danger') : ''"
        v-bind:title="initialValue"
        v-bind:value="initialValue"
        v-bind:value-key="valueKey"
        @change="onSelect(isType,name, $event)"
        :placeholder="placeholder"
        size="small"
        v-if="type === isType || !data"
    >
        <template v-if="groupped">
            <el-option-group
                v-for="op in optionList"
                :key="op.label"
                :label="op.label">
                <el-option
                    v-for="(item, i) in op.options"
                    :key="i"
                    :label="item.name"
                    :value="item[valueKey]"
                >
                </el-option>
            </el-option-group>
        </template>
        <template v-else>
            <el-option
                v-for="(item, i) in optionList"
                :key="i"
                :label="item.name"
                :value="item[valueKey]"
            >
            </el-option>
        </template>
    </el-select>
    <span v-else>{{ data }}</span>
</template>
<script>
export default {
    name: 'resolve-by-list',
    props: {
        name: {
            type: String,
            required: true
        },
        data: {
            type: [String, Boolean],
            required: true
        },
        type: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        isType: {
            type: String,
            required: true
        },
        optionList: {
            type: Array,
            defaul() {
                return []
            }
        },
        valueKey: {
            type: String
        },
        groupped: {
            type: Boolean,
            default() {
                return false
            }
        },
        initialValue: {
            type: String
        }
    },
    data() {
        return {
            value: this.initialValue
        }
    },
    methods: {
        onSelect(type, name, item) {
            this.value = item.name
            const itemList = !this.groupped ? 
                this.optionList.find(op => op[this.valueKey] === item)
                : this.optionList.reduce((acc,op) => {
                    const m = op.options.find(el => el.id === item)
                    if(m) {

                        acc = {
                            ...m,
                            provider: op.provider
                        }
                    }
                    return acc
                }, {})
            this.$emit("onSelect", {
                type,
                item: itemList,
                name
            })
        }
    }
}
</script>
<style lang="scss">
    .success {
        input {
            border-color: rgb(103, 194, 58) !important;
            background-color: #f6fff8;
        }
    }

    .danger {
        input {
            border-color: rgb(245, 108, 108) !important;
        }
    }
</style>